import type { Tokens } from '../../../../theming/types'
import type { BelowInputContainerProps } from '../BelowInputContainer'

export default (config: {
  props: Pick<BelowInputContainerProps, 'disabled'> & {
    showDefaultError?: boolean
  }
  tokens: Tokens
}) => {
  const { props, tokens } = config

  return {
    wrap: {
      alignItems: 'center',
      cursor: props.disabled ? 'not-allowed' : undefined,
      display: 'flex',
      justifyContent: 'space-between',
      marginBlockStart: tokens.spacingGap50,
      opacity: props.disabled ? tokens.opacityDisabled : undefined,
      position: 'relative',
      width: props.showDefaultError ? '100%' : undefined,
    },

    count: {
      width: props.showDefaultError ? undefined : '100%',
    },
  } as const
}
